import React from "react";

import { Select } from "../../../../../components/ui";
import { COMPLIANCE_WITHDRAWAL_STATUS_OPTIONS } from "../../../../../components/ui/ComplianceWithdrawalStatusSelect";

interface IProps {
  complianceStatus: string;
  setComplianceStatus: (status: string) => void;
}
const ComplianceStatusSelect: React.FC<IProps> = ({ complianceStatus, setComplianceStatus }) => {
  return (
    <Select
      label="Compliance Status"
      inputLabel="Compliance Status"
      name="complianceStatus"
      value={complianceStatus}
      onChange={(e) => setComplianceStatus(e.target.value as string)}
      options={[
        {
          label: "All",
          value: "all",
        },
        ...COMPLIANCE_WITHDRAWAL_STATUS_OPTIONS,
      ].map((opt) => ({
        text: opt.label as string,
        name: opt.value,
      }))}
    />
  );
};

export default ComplianceStatusSelect;
